import { render, staticRenderFns } from "./issueQuantity.vue?vue&type=template&id=0a2c4e91&lang=pug&"
import script from "./issueQuantity.vue?vue&type=script&lang=js&"
export * from "./issueQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports